import customMapBoxGL from './customMapBoxGL';
import adaptURL from '../adapt-url';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

/**
 * Builds the MapBox GL layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {number} [arg.zIndex = 10] - The zIndex for the layer.
 * @returns {object} The leaflet layer to add to the map.
 */
const buildMapBoxGLLayer = ({ layer, style, zIndex = 10 }) =>
  customMapBoxGL({
    accessToken: layerOps.getAccessToken(layer),
    style: adaptURL(layerOps.getURL(layer)),
    opacity: styleOps.getRasterOpacityPercentage(style) / 100,
    pane: `${zIndex}`,
    attribution: layerOps.getAttribution(layer),
    interactive: true
  });

export default buildMapBoxGLLayer;
